export function SmallSolidButton({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center space-x-1 
        text-xs font-medium-200 
        text-slate-100 bg-blue-600
        hover:bg-blue-700 px-3 py-[4px] rounded-sm 
        cursor-pointer
        hover:shadow-xl hover:shadow-blue-500/20 transition-all duration-300 group"
    >
      {children}
    </button>
  );
}